export default {"src":"/_next/static/media/ibisg.e1bb8a60.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};